<template>
  <div ref="container" class="s-leaseitnow-vehicle-slick">
    <div v-if="percentage" class="s-leaseitnow-vehicle-slick__progress-bar">
      <ProgressBar :percentage="percentage" />
    </div>

    <SlickCarousel
      ref="slick"
      :key="'key-' + slickKey"
      class="s-leaseitnow-vehicle-slick__slick"
      :options="slickOptions"
      @init="onInit"
      @beforechange="onBeforeChange">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="s-leaseitnow-vehicle-slick__slide item">
        <a
          class="s-leaseitnow-vehicle-slick__image"
          data-fancybox="gallery"
          :href="item.image?.url">
          <img
            v-if="item.thumbnail"
            ref="image"
            :src="item.thumbnail.url"
            :data-src="item.thumbnail.url"
            :alt="item.thumbnail.alt" />
          <i class="icon-zoom"></i>
          <!-- <div v-if="item.isNew" class="e-new"><NewLottie /></div> -->
          <div v-if="item.offerText" class="offer-text">
            {{ item.offerText }}
          </div>
        </a>
      </div>
    </SlickCarousel>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'
import ProgressBar from './../common/ProgressBar.vue'
import SlickCarousel from '../common/SlickCarousel.vue'
import { Fancybox } from '@fancyapps/ui'
import jQuery from 'jquery'
// import NewLottie from './../../components/lotties/New.vue'

export default {
  components: {
    ProgressBar,
    SlickCarousel,
    // NewLottie
  },
  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      percentage: 0,
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 2, variableWidth: false },
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1, variableWidth: false },
          },
        ],
      },
      fancyboxOptions: {
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ['close'],
          },
        },
      },
    }
  },
  mounted() {
    Fancybox.bind(this.$refs.container, '[data-fancybox]', this.fancyboxOptions)
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick, _, nextSlide) {
      if (nextSlide === slick.slideCount - 1) {
        const padding =
          (jQuery('.slick-slider').width() -
            jQuery('.slick-slide:last-child').width()) *
          1.1
        jQuery('.slick-list').css('padding-left', padding)
      } else {
        jQuery('.slick-list').removeAttr('style')
      }
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
